<template>
  <div class="search">
    <!-- 头部 -->
    <div class="bgwhite wp100" id="header">
      <div class="w1200 header flex align-center justify-between">
        <!-- logo -->
        <router-link to="/index">
          <img src="../assets/images/logo.png" alt="" />
        </router-link>
        <!-- 搜索框 -->
        <div>
          <input
            id="kw"
            name="wd"
            v-model="searchValue"
            maxlength="255"
            autocomplete="off"
            :placeholder="$t('searchContent')"
            ref="inputdata"
            @keyup.enter="enterSubmit"
          />
          <button type="primary" id="su" @click="handleSearch">
            <i class="el-icon-search f24"></i>
          </button>
        </div>
        <!-- 头像 -->
        <el-dropdown @command="handleCommand">
          <div class="el-dropdown-link textc">
            <img
              :src="logo"
              alt=""
              height="50"
              width="50"
              style="border-radius: 50%"
            />
             <span class="dian positiona" style="color: #ff3737 !important;" v-if="isMsg == '1'">●</span>
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="/my/personalInfo">
              <div class="flex align-center dropdown_item">
                <img
                  src="../assets/images/my_info.png"
                  alt=""
                  width="20"
                  height="20"
                />
                <span class="ml10 f15">{{ $t("navbar.personalData") }}</span>
              </div>
            </el-dropdown-item>
            <el-dropdown-item command="/my/myMessage">
              <div class="flex align-center dropdown_item">
                <img
                  src="../assets/images/my_message.png"
                  alt=""
                  width="20"
                  height="20"
                />
                <span class="dian positiona"
                        v-if="isMsg == '1'">●</span>
                <span class="ml10 f15">{{ $t("navbar.myMessage") }}</span>
              </div>
            </el-dropdown-item>
            <el-dropdown-item command="/my/trainingTest">
              <div class="flex align-center dropdown_item">
                <img
                  src="../assets/images/my_trian.png"
                  alt=""
                  width="20"
                  height="20"
                />
                <span class="ml10 f15">{{ $t("navbar.trainingTest") }}</span>
              </div>
            </el-dropdown-item>
            <el-dropdown-item command="/my/testCenter">
              <div class="flex align-center dropdown_item">
                <img
                  src="../assets/images/my_exam.png"
                  alt=""
                  width="20"
                  height="20"
                />
                <span class="ml10 f15">{{ $t("navbar.testCenter") }}</span>
              </div>
            </el-dropdown-item>
            <el-dropdown-item command="/my/favorites">
              <div class="flex align-center dropdown_item">
                <img
                  src="../assets/images/my_like.png"
                  alt=""
                  width="20"
                  height="20"
                />
                <span class="ml10 f15">{{ $t("navbar.favorites") }}</span>
              </div>
            </el-dropdown-item>
            <el-dropdown-item command="/my/browserHistory">
              <div class="flex align-center dropdown_item">
                <img
                  src="../assets/images/my_history.png"
                  alt=""
                  width="20"
                  height="20"
                />
                <span class="ml10 f15">{{ $t("navbar.browserHistory") }}</span>
              </div>
            </el-dropdown-item>
            <el-dropdown-item divided command="loginout">
              <div class="dropdown_item f15 fw700 textc">
                {{ $t("navbar.logOut") }}
              </div>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <div class="w1200 pt90">
      <!-- 历史搜索 -->
      <div
        class="history mt30 bgwhite bbox pl20 pr20 pt25 pb10"
        v-if="searchValue.length == 0"
      >
        <div class="f18 fw700 pb20 flex justify-between">
          <div>{{ $t("searchHistory") }}</div>
          <i class="el-icon-delete pointer" @click="delAll"></i>
        </div>
        <div class="flex text666 f16 historyList mt10">
          <div
            class="mr40 mb15 pointer positionr"
            v-for="searchRecord in searchList"
            :key="searchRecord.id"
            @click="searchAction(searchRecord.keyword)"
          >
            {{ searchRecord.keyword }}
            <i
              class="el-icon-error positiona del pointer"
              @click.stop="deleteSearchRecord(searchRecord)"
            ></i>
          </div>
        </div>
      </div>
      <!-- 搜索结果 -->
      <div v-else>
        <div class="tip pt15 pb15 text666 f16 pl15 bbox">
          {{ $t("searching") }}：<span class="pl10 text333 fw600">{{
            searchValue
          }}</span>
        </div>
        <div>
          <!-- 暂无收藏 -->
          <div
            v-if="
              dataList.length == 0 &&
              machineList.length == 0 &&
              falutList.length == 0
            "
            class="noMessage positiona"
          >
            <img src="../assets/images/kong.png" alt="" width="150" />
            <div class="f17 textc mt15">{{ $t("my.noTestLogging") }}</div>
          </div>
          <!-- 故障手册类 -->
          <div
            class="documents bgwhite pl20 pr20 bbox pt15 pb20 mb15"
            v-if="falutList.length > 0"
          >
            <div class="f16 fw700 mb20">{{ $t("faultClass") }}</div>
            <ul class="f15 text666">
              <li
                class="mb10 pointer"
                v-for="data in falutList"
                :key="data.typeCode"
                @click="
                  toEquipmentDetailsByLevel_4(data.typeCode, data.typeName,null,data.modelName)
                "
              >
                <span style="color:#000;font-weight:550;">【{{data.modelName}}】</span>{{ data.typeName }}
              </li>
            </ul>
          </div>
          <!-- 文档类 -->
          <div
            class="documents bgwhite pl20 pr20 bbox pt15 pb20 mb15"
            v-if="dataList.length > 0"
          >
            <div class="f16 fw700 mb20">{{ $t("documentClass") }}</div>
            <ul class="f15 text666">
              <li
                class="mb10 pointer"
                v-for="data in dataList"
                :key="data.id"
                @click="
                  toEquipmentDetailsByLevel_4(
                    data.typeCode,
                    data.typeName,
                    data.parentCode,
                    data.modelName,
                  )
                "
              >
                <span style="color:#000;">【{{data.modelName}}】</span>{{ data.typeName }}
              </li>
            </ul>
          </div>
          <!-- 仪器类 -->
          <div
            class="instruments bgwhite pl20 pr20 bbox pt15 pb20 mb15"
            v-if="machineList.length > 0"
          >
            <div class="f16 fw700 mb20">{{ $t("InstrumentClass") }}</div>
            <div class="flex align-center flex-wrap bbox pl20 pr20">
              <div
                class="item bbox"
                v-for="machineType in machineList"
                :key="machineType.id"
                @click="
                  toEquipmentDetails(machineType.typeCode, machineType.typeName)
                "
              >
                <div class="pic">
                  <!-- <img :src="machineType.logo"
                       alt="" /> -->
                  <el-image
                    :src="machineType.logo"
                    fit="cover"
                    :lazy="lazyFalg"
                    style="width: 100%; height: 150px"
                    ref="imghead"
                  >
                    <div
                      slot="placeholder"
                      class="image-slot text999 hp100 f24 flex align-center justify-center"
                    >
                      <i class="el-icon-loading"></i>
                    </div>
                    <div
                      slot="error"
                      class="image-slot text999 hp100 f24 flex align-center justify-center"
                    >
                      <i class="el-icon-picture-outline"></i>
                    </div>
                  </el-image>
                </div>
                <div class="texts-cut2 mt15 textc tit">
                  {{ machineType.typeName }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--弹出组件-->
    <div>
      <el-dialog
        :title="previewAreaTittle"
        v-if="dialogVisibal"
        :visible.sync="dialogVisibal"
        :lock-scroll="false"
        width="90%"
      >
        <PreviewArea></PreviewArea>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import PreviewArea from "@/views/PreviewArea.vue";
import objectFitImages from "object-fit-images";
var tips1 = "确定删除此记录吗?";
var tips2 = "温馨提示";
var tips3 = "确定";
var tips4 = "取消";
var tips5 = "提示";
var tips6 = "成功删除1条历史记录";
var tips7 = "已取消删除";
var tips8 = "确定删除全部记录吗?";
var tips9 = "成功删除";
var tips10 = "已取消删除";
export default {
  components: {
    PreviewArea,
  },
  data() {
    return {
      searchValue: "",
      member: {},
      logo: "",
      searchList: [],
      machineList: [],
      dataList: [],
      examList: [],
      dialogVisibal: false,
      previewAreaTittle: "",
      lazyFalg: true,
      falutList: [],
      isMsg: "0",
    };
  },
  methods: {
       // 回车事件
    enterSubmit() {
      this.handleSearch();
    },
    //查询搜索结果
    async handleSearch() {
      //保存搜索记录
      if (this.member.isLogin) {
        var sendData = {};
        sendData.memberCode = localStorage.getItem("memberCode");
        sendData.keyword = this.searchValue;
        var that = this;
        await this.$http
          .post("memberSearchRecords/saveMemberSearchRecords", sendData)
          .then(function (res) {
            if (200 == res.data.code) {
              that.getHistorySearchRecord(that.member.memberCode);
            }
          });
      }
      //查询搜索结果
      var sendData = {};
      sendData.memberCode = this.member.memberCode;
      sendData.keyword = this.searchValue;
      var that = this;
      this.$http
        .post("memberSearchRecords/searchData", sendData)
        .then(function (res) {
          if (200 == res.data.code) {
            // console.log('搜索结果',res)
            that.dataList = res.data.data.data;
            that.machineList = res.data.data.machine;
            that.falutList = res.data.data.fault;
          }
        });
    },

    queryMsgCount (memberCode) {
      var sendData = {};
      sendData.memberCode = memberCode;
      var that = this;
      this.$http
        .post("memberMsg/queryNoReadCount", sendData)
        .then(function (res) {
          if (200 == res.data.code) {
            var count = res.data.data;
            if (count > 0) {
              that.isMsg = "1";
            } else {
              that.isMsg = "0";
            }
          }
        });
    },

    searchAction(txt) {
      this.searchValue = txt;
      this.handleSearch();
    },
    handleCommand(command) {
      // 退出登录
      if (command == "loginout") {
        this.$router.push("/login");
        localStorage.removeItem("member");
        localStorage.removeItem("memberCode");
      } else {
        this.$router.push({ path: command });
      }
    },
    //改变元素#searchBar的top值
    handleScroll() {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      // console.log("滚动条距离顶部" + scrollTop);
      if (scrollTop > 0) {
        $("#header").addClass("handleScorll");
      } else {
        $("#header").removeClass("handleScorll");
      }
    },
    //查询历史搜索记录
    getHistorySearchRecord(memberCode) {
      var sendData = {};
      sendData.memberCode = memberCode;
      var that = this;
      this.$http
        .post("memberSearchRecords/queryMemberSearchRecordsList", sendData)
        .then(function (res) {
          if (200 == res.data.code) {
            that.searchList = res.data.data;
          }
        });
    },
    //删除单条搜索记录
    deleteSearchRecord(record) {
      this.$confirm(tips1, tips2, {
        confirmButtonText: tips3,
        cancelButtonText: tips4,
        type: "warning",
      })
        .then(() => {
          var sendData = {};
          sendData.id = record.id;
          var that = this;
          this.$http
            .post("memberSearchRecords/delete", sendData)
            .then(function (res) {
              if (200 == res.data.code) {
                var index = that.searchList.indexOf(record);
                that.searchList.splice(index, 1);
              }
            });
          // 确定删除
          this.$notify.success({
            title: tips5,
            message: tips6,
          });
        })
        .catch(() => {
          //  取消删除
          this.$notify.info({
            title: tips5,
            message: tips7,
          });
        });
    },
    // 删除全部搜索记录
    delAll() {
      this.$confirm(tips8, tips2, {
        confirmButtonText: tips3,
        cancelButtonText: tips4,
        type: "warning",
      })
        .then(() => {
          var sendData = {};
          sendData.memberCode = localStorage.getItem("memberCode");
          var that = this;
          this.$http
            .post("memberSearchRecords/deleteMemberSearchRecords", sendData)
            .then(function (res) {
              if (200 == res.data.code) {
                that.searchList = [];
                // 确定删除
                that.$notify.success({
                  title: tips5,
                  message: tips9,
                });
              }
            });
        })
        .catch(() => {
          //  取消删除
          this.$notify.info({
            title: tips5,
            message: tips7,
          });
        });
    },
    //跳转到指定设备
    toEquipmentDetails(typeCode, typeName) {
      this.$router.push({
        path: "/equipmentDetails",
        query: {
          typeCode: typeCode,
          typeName: typeName,
        },
      });
    },
    //跳转到指定文档
    toEquipmentDetailsByLevel_4(typeCode, typeName, parentCode,machineType) {
      this.previewAreaTittle = typeName;
      var sendData = {};
      sendData.objectCode = typeCode;
      var that = this;
      this.$http.post("annexFile/queryFileList", sendData).then(function (res) {
        if (200 == res.data.code) {
          var file = res.data.data[0];
          if (file != undefined && file.fileUrl != undefined) {
            var url = file.fileUrl;
            var content = file.represent;
            var data = {};
            data.url = url;
            data.typeCode = typeCode;
            data.typeName = typeName;
            data.machineType = machineType;
            data.content = content;
            var tempData = JSON.stringify(data);
            let routeUrl = that.$router.resolve({//typeName=HA-8180&typeCode=677539124&pageStatus=1
              path: "/previewAreaSearch",
              query: { url: tempData
                     },
            });
            window.open(routeUrl.href, "_blank");
          } else {
            that.$message("无文件地址,请联系管理员!");
          }
        }
      });
    },
    changeLanguage() {
      if (this.$store.getters.language == "zh") {
        tips1 = "确定删除此记录吗?";
        tips2 = "温馨提示";
        tips3 = "确定";
        tips4 = "取消";
        tips5 = "提示";
        tips6 = "成功删除1条历史记录";
        tips7 = "已取消删除";
        tips8 = "确定删除全部记录吗?";
        tips9 = "成功删除";
        tips10 = "已取消删除";
      }
      if (this.$store.getters.language == "en") {
        tips1 = "Are you sure to delete this record?";
        tips2 = "Warm prompt";
        tips3 = "determine";
        tips4 = "cancel";
        tips5 = "prompt";
        tips6 = "1 history record was successfully deleted";
        tips7 = "Canceled Delete";
        tips8 = "Are you sure to delete all records?";
        tips9 = "Deleted successfully";
        tips10 = "Canceled Delete";
      }
      if (this.$store.getters.language == "ja") {
        tips1 = "この記録は削除されますか?";
        tips2 = "暖かいヒント";
        tips3 = "確定";
        tips4 = "キャンセル";
        tips5 = "提示";
        tips6 = "履歴を1件削除することに成功した";
        tips7 = "取り消し削除済み";
        tips8 = "全記録削除は確定ですか?";
        tips9 = "削除成功";
        tips10 = "取り消し削除済み";
      }
    },
  },
  created() {
    this.searchValue = this.$route.query.searchValue;
    this.$nextTick(() => {
      this.$refs.inputdata.focus();
    });
    this.member = JSON.parse(localStorage.getItem("member"));
    if (this.member.isLogin) {
      this.logo = this.member.logo;
    }
    if (!(!this.searchValue || !this.searchValue)) {
      this.handleSearch();
    }
    this.changeLanguage();
    objectFitImages(this.$refs.imghead);
  },
  mounted() {
    this.getHistorySearchRecord(this.member.memberCode);
    this.queryMsgCount(this.member.memberCode);
    //给window添加一个滚动滚动监听事件
    window.addEventListener("scroll", this.handleScroll);
    this.changeLanguage();
    objectFitImages(this.$refs.imghead);
  },
  updated() {
    this.changeLanguage();
  },
};
</script>

<style scoped>
.search {
  min-height: calc(100vh - 70px);
}
.historyList > div:hover {
  color: #1f8bd0;
}
.documents ul li:hover {
  color: #1f8bd0;
  text-decoration: underline;
}
.del {
  top: -10px;
  right: -10px;
}
.instruments .item {
  width: calc((100% - 80px) / 5);
  padding: 15px 33px;
  margin-right: 20px;
  margin-bottom: 20px;
  cursor: pointer;
  transition: all 0.3s;
  border: 1px solid #f8f8f8;
}
.instruments .item:nth-child(5n) {
  margin-right: 0;
}
.instruments .item .pic {
  width: 100%;
  height: 150px;
}
.instruments .item .pic img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.instruments .item:hover {
  box-shadow: 0 2px 15px rgba(0, 0, 0, 0.2);
}
.instruments .item:hover .tit {
  color: #1f8bd0;
}
#header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 100;
}
.handleScorll {
  box-shadow: 5px 0 15px rgba(0, 0, 0, 0.1);
}
.noMessage {
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
